import { useQuery } from "@tanstack/react-query";
import {
  dashboardService,
  type UserDashboardOverview,
} from "@/services/dashboard/dashboard.service";
import { useAuthStore } from "@/store/use-auth-store";
import { useCompanyStore } from "@/store/use-company-store";

export function useUserDashboard() {
  const { isAuthenticated } = useAuthStore();
  const { currentCompanyId } = useCompanyStore();

  return useQuery<UserDashboardOverview>({
    queryKey: ["dashboard", "me", currentCompanyId],
    queryFn: () => dashboardService.getUserOverview(),
    enabled: isAuthenticated && !!currentCompanyId,
    staleTime: 30_000,
    refetchInterval: 60_000,
    refetchOnWindowFocus: false,
  });
}
